<template>
  <div>
      <div class="page-header page-header-small">
        <parallax
          class="page-header-image"
          style="background-image: url('../img/bg6.jpg')"
        >
        </parallax>
        <div class="content-center">
          <div class="container">
            <h1 class="title">Somos calidad en tecnología</h1>
            <div class="text-center">
              <a href="#pablo" class="btn btn-primary btn-icon btn-round">
                <i class="fab fa-facebook-square"></i>
              </a>
              <a href="#pablo" class="btn btn-primary btn-icon btn-round">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="#pablo" class="btn btn-primary btn-icon btn-round">
                <i class="fab fa-google-plus"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="row">
            <h2 class="title">Nuestros productos y servicios</h2>
            <div class="grid-filter col-md-12">
              <FilterProducts />
              <GridProducts />
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { Button } from "../components";
// import BasicElements from './components/BasicElementsSection';
// import Navigation from './components/Navigation';
import GridProducts from "./components/GridProducts.vue";
import FilterProducts from "./components/FilterProducts.vue";
// import ProgressPagination from './components/ProgressPagination';
// import Notifications from './components/Notifications';
// import Typography from './components/Typography';
// import JavascriptComponents from './components/JavascriptComponents';
// import CarouselSection from './components/CarouselSection';

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    // BasicElements,
    // Navigation,
    [Button.name]: Button,
    GridProducts,
    FilterProducts,
    // ProgressPagination,
    // Notifications,
    // Typography,
    // JavascriptComponents,
    // CarouselSection,
  },
};
</script>
<style scoped>
.grid-filter {
  display: grid;
  grid-template-columns: 0.2fr 1fr;
}
</style>
